// src/components/CropcBlog.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const CropcBlog = () => {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1>CropC Blog</h1>
      <p>Latest updates and articles.</p>
      <button onClick={() => navigate('/cropc-blog')}>
        Go to CropC Blog
      </button>
    </div>
  );
};

export default CropcBlog;
